import authCheckApp from './authCheckApp'

/**
 * 显示加载框
 * @since 1.0.0
 * @example
 * 
 * showProgress()
 */
function showProgress() {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('showProgress', {}, (response) => {
                return response
            })
        })
}

export default showProgress